import { configureStore } from '@reduxjs/toolkit';

import reducer from '@/store/ducks/root';

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

export default store;
